import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsReportsTemplateRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-reports',
	path: '/jira/servicedesk/assets/reports/:templateId',
	exact: true,
};
